// Contenu de référence sur les questions d'IA et pédagogie
export const CONTENT_REFERENCE = `
AI and Pedagogy: 4 Key Questions for HEC Professors
Introduction
This mini-content is designed to introduce HEC professors to the transformative potential of AI in higher education. Rather than providing definitive answers, our goal is to spark reflection and dialogue about how AI might reshape teaching and learning at HEC. By examining these four questions, we'll explore both opportunities and challenges presented by AI integration in your educational practice.

Question 1: How does AI transformation challenge and redefine the traditional role of professors?
Key considerations:
The shifting balance between knowledge transmission and facilitation of learning
The concept of "team-teaching" between human professors and AI agents
Finding the optimal combination of human expertise and AI capabilities
The importance of human presence, empathy, and connection in the learning process
"This approach involves a collaborative teaching model where both human teachers and GAI teachers work together. The human teacher brings expertise in pedagogy, subject knowledge, and emotional intelligence, while the GAI teacher offers versatile information processing capabilities, personalized learning suggestions, and data-driven feedback." (Lan & Chen, 2024, p. III)

Question 3: What are the concerns professors should address regarding student use of AI for academic work?
Key considerations:
Over-reliance on AI for completing assignments
The challenge of authenticating student-generated versus AI-generated work
Students treating AI as an advanced search engine rather than as a learning partner
Teaching students to use AI as a tool for enhancing understanding rather than bypassing learning
"Teachers are apprehensive that students might overly depend on AI tools to complete their assignments. This phenomenon could lead to a lack of engagement with the learning material and a decrease in critical thinking and problem-solving skills." (Lan & Chen, 2024, p. I)

Question 5: How can professors leverage AI to enhance their teaching efficiency and effectiveness?
Key considerations:
Using AI for routine tasks to free up time for higher-value teaching activities
Generating and curating content with AI assistance
Employing AI for personalized content delivery and feedback
Maintaining the human connection while incorporating AI efficiencies
"Teachers are seeking ways to use AI to augment student learning, reduce their teaching workload, and improve the overall teaching quality. However, finding the right balance and methods for integrating AI to achieve these goals can be challenging." (Lan & Chen, 2024, p. II)

Question 6: What stance should professors take regarding student use of AI in their courses?
Key considerations:
Developing clear guidelines for appropriate AI use in coursework
Teaching students to use AI critically and effectively as a learning tool
Redesigning assessments to work with rather than against AI capabilities
Viewing AI literacy as an essential skill for future professionals
"The challenge is to encourage students to use AI as a tutor for boosting their exploration rather than the endpoint of their learning journey." (Lan & Chen, 2024, p. II)
`;

// Key questions and associated keywords for detection
export const KEY_QUESTIONS = {
  1: {
    question: "How does AI redefine the traditional role of professors?",
    keywords: ["role", "professor", "teacher", "transmission", "team-teaching", "human presence", "empathy"]
  },
  3: {
    question: "What concerns should be addressed regarding student use of AI?",
    keywords: ["concerns", "dependence", "authentication", "plagiarism", "bypass", "cheating"]
  },
  5: {
    question: "How can professors use AI to improve their efficiency?",
    keywords: ["efficiency", "routine tasks", "time", "content generation", "workload", "quality"]
  },
  6: {
    question: "What stance should be adopted toward student use of AI?",
    keywords: ["stance", "guidelines", "rules", "assessments", "AI literacy", "competence"]
  }
};
